import { Checkbox, FormControlLabel, IconButton } from '@mui/material';
import { ReactElement } from 'react';
import { SortableItem, SortableKnob } from 'react-easy-sort';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';

import {
  ColouredDragIcon,
  StyledFlavourName,
  StyledFlavourNameWrapper,
  StyledFlavourWrapper,
  StyledProductCode,
  StyledUnsortableWrapper,
} from '../../ProductVariationsAccordion.styled';
import { ProductVariationFlavorProps } from './ProductVariationFlavor.interface';

const FlavourName = ({ name }: { name?: string }) => {
  return (
    <CustomTooltip
      width={500}
      placement="right"
      overflowLineNumber={1}
      title={name}>
      <StyledFlavourName>{name}</StyledFlavourName>
    </CustomTooltip>
  );
};

const CustomSortableItem = (props: {
  sortable: boolean;
  children: ReactElement;
}) => {
  return (
    <>
      {props.sortable ? (
        <SortableItem>
          <StyledFlavourWrapper>
            <SortableKnob>
              <IconButton
                sx={{
                  marginLeft: '-10px',
                  cursor: 'grab',
                }}>
                <ColouredDragIcon />
              </IconButton>
            </SortableKnob>
            {props.children}
          </StyledFlavourWrapper>
        </SortableItem>
      ) : (
        <StyledUnsortableWrapper>{props.children}</StyledUnsortableWrapper>
      )}
    </>
  );
};

export const ProductVariationFlavor = (props: ProductVariationFlavorProps) => {
  return (
    <CustomSortableItem sortable={props.sortable}>
      <FormControlLabel
        sx={{
          overflow: 'hidden',
          width: 'fill-available',
        }}
        label={
          <StyledFlavourNameWrapper>
            <FlavourName name={props.flavor.name || 'None'} />
            <StyledProductCode>{`[${props.flavor.productCode}]`}</StyledProductCode>
          </StyledFlavourNameWrapper>
        }
        checked={Boolean(props.flavor.order)}
        control={<Checkbox onChange={props.onChange} />}
      />
    </CustomSortableItem>
  );
};
